import { Search, Filter, ChevronDown } from "lucide-react";
import { ghanaRegions } from "../../../../data/ghanaRegionsAndLocations";

const ClientFilters = ({
  searchTerm,
  setSearchTerm,
  statusFilter,
  setStatusFilter,
  regionFilter,
  setRegionFilter,
  sortBy,
  setSortBy,
  sortOrder,
  setSortOrder,
  showMobileFilters,
  setShowMobileFilters,
}) => {
  const hasActiveFilters =
    searchTerm || statusFilter !== "all" || regionFilter !== "all";

  const clearFilters = () => {
    setSearchTerm("");
    setStatusFilter("all");
    setRegionFilter("all");
  };

  return (
    <div className="p-4 bg-white rounded-lg border border-gray-200 shadow-sm sm:rounded-xl sm:p-6">
      {/* Mobile Filter Toggle */}
      <div className="flex justify-between items-center mb-4 lg:hidden">
        <h3 className="flex items-center text-base font-semibold text-gray-900">
          <Filter className="mr-2 w-4 h-4 text-emerald-600" />
          Filters
        </h3>
        <button
          onClick={() => setShowMobileFilters(!showMobileFilters)}
          className="flex items-center px-3 py-2 text-sm bg-gray-100 rounded-lg transition-colors hover:bg-gray-200 touch-manipulation"
        >
          <span>Filters</span>
          <ChevronDown
            className={`w-4 h-4 ml-2 transition-transform ${
              showMobileFilters ? "rotate-180" : ""
            }`}
          />
        </button>
      </div>

      {/* Desktop Filter Header */}
      <div className="hidden justify-between items-center mb-6 lg:flex">
        <h3 className="flex items-center text-lg font-semibold text-gray-900">
          <Filter className="mr-2 w-5 h-5 text-emerald-600" />
          Filters & Search
        </h3>
      </div>

      {/* Filter Controls */}
      <div
        className={`space-y-4 ${
          showMobileFilters ? "block" : "hidden lg:block"
        }`}
      >
        {/* Search */}
        <div className="relative">
          <Search className="absolute top-3 left-3 w-4 h-4 text-gray-400 sm:w-5 sm:h-5" />
          <input
            type="text"
            placeholder="Search clients by name, email, document, ID..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="py-3 pr-4 pl-10 w-full text-sm rounded-lg border border-gray-300 transition-all sm:text-base focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
          />
        </div>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4 sm:gap-4">
          {/* Status Filter */}
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="px-3 py-3 text-sm bg-white rounded-lg border border-gray-300 appearance-none sm:px-4 focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
          >
            <option value="all">All Status</option>
            <option value="active">Active Only</option>
            <option value="pending">Pending Only</option>
            <option value="inactive">Inactive Only</option>
          </select>

          {/* Region Filter */}
          <select
            value={regionFilter}
            onChange={(e) => setRegionFilter(e.target.value)}
            className="px-3 py-3 text-sm bg-white rounded-lg border border-gray-300 appearance-none sm:px-4 focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
          >
            <option value="all">All Regions</option>
            {ghanaRegions.map((region) => (
              <option key={region} value={region.toLowerCase()}>
                {region}
              </option>
            ))}
          </select>

          {/* Sort */}
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            className="px-3 py-3 text-sm bg-white rounded-lg border border-gray-300 appearance-none sm:px-4 focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
          >
            <option value="name">Sort by Name</option>
            <option value="email">Sort by Email</option>
            <option value="location">Sort by Location</option>
            <option value="document">Sort by Document</option>
            <option value="status">Sort by Status</option>
          </select>

          {/* Sort Order */}
          <button
            onClick={() => setSortOrder(sortOrder === "asc" ? "desc" : "asc")}
            className="flex justify-center items-center px-3 py-3 text-sm bg-gray-100 rounded-lg border border-gray-300 transition-colors sm:px-4 hover:bg-gray-200 active:bg-gray-300 touch-manipulation"
          >
            {sortOrder === "asc" ? "↓" : "↑"}{" "}
            {sortOrder === "asc" ? "Ascending" : "Descending"}
          </button>
        </div>
      </div>

      {/* Clear Filters Button */}
      {hasActiveFilters && (
        <div className="flex justify-end mt-4">
          <button
            onClick={clearFilters}
            className="px-3 py-2 text-sm text-red-600 rounded-lg transition-colors hover:text-red-700 hover:bg-red-50"
          >
            Clear Filters
          </button>
        </div>
      )}
    </div>
  );
};

export default ClientFilters;
